import React from "react";
import { Modal } from "react-bootstrap";

const FilePreviewModal = ({ show, onHide, file }) => {
  if (!file) return null;

  const { url, name, type } = file;

  const handleDownload = () => {
    window.open(url, '_blank');
  };

  const renderPreviewContent = () => {
    switch (type) {
      case "image":
        return (
          <div className="fm-preview-image-container">
            <img
              src={url}
              alt={name}
              className="fm-preview-image"
            />
          </div>
        );

      case "pdf":
        return (
          <div className="fm-preview-pdf-container">
            <iframe
              src={url}
              title={`PDF Preview - ${name}`}
              className="fm-preview-pdf"
            />
          </div>
        );

      case "audio":
        return (
          <div className="fm-preview-audio-container">
            <div className="fm-audio-icon">
              <i className="bi bi-music-note-beamed"></i>
            </div>
            <h5 className="fm-preview-filename">{name}</h5>
            <audio controls className="fm-audio-player">
              <source src={url} />
              Your browser does not support the audio element.
            </audio>
          </div>
        );

      case "video":
        return (
          <div className="fm-preview-video-container">
            <video controls className="fm-preview-video">
              <source src={url} />
              Your browser does not support the video element.
            </video>
          </div>
        );

      case "text":
        return (
          <div className="fm-preview-text-container">
            <iframe
              src={url}
              title={`Text Preview - ${name}`}
              className="fm-preview-text"
            />
          </div>
        );

      default:
        return (
          <div className="fm-preview-fallback">
            <div className="fm-fallback-icon">
              <i className="bi bi-file-earmark"></i>
            </div>
            <h5 className="fm-preview-filename">{name}</h5>
            <p className="fm-fallback-message">
              This file type cannot be previewed in the browser.
            </p>
            <button
              className="fm-download-btn"
              onClick={handleDownload}
            >
              <i className="bi bi-download me-2"></i>
              Open / Download
            </button>
          </div>
        );
    }
  };

  const getModalSize = () => {
    if (type === "pdf" || type === "video") return "xl";
    if (type === "image") return "lg";
    return "md";
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={getModalSize()}
      className="fm-preview-modal"
      contentClassName="fm-preview-modal-content"
    >
      {/* Header */}
      <Modal.Header className="fm-preview-header">
        <div className="fm-preview-header-info">
          <i className={`bi ${getFileIconClass(type)} me-2`}></i>
          <span className="fm-preview-title" title={name}>
            {name.length > 40 ? `${name.substring(0, 40)}...` : name}
          </span>
        </div>
        <div className="fm-preview-header-actions">
          <button
            className="fm-header-btn"
            onClick={handleDownload}
            title="Open in new tab"
          >
            <i className="bi bi-box-arrow-up-right"></i>
          </button>
          <button
            className="fm-header-btn fm-close-btn"
            onClick={onHide}
            title="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      </Modal.Header>

      {/* Body */}
      <Modal.Body className="fm-preview-body p-0">
        {renderPreviewContent()}
      </Modal.Body>
    </Modal>
  );
};

const getFileIconClass = (type) => {
  switch (type) {
    case "image": return "bi-file-image";
    case "pdf": return "bi-file-pdf";
    case "audio": return "bi-file-music";
    case "video": return "bi-file-play";
    case "word": return "bi-file-word";
    case "excel": return "bi-file-excel";
    case "text": return "bi-file-text";
    default: return "bi-file-earmark";
  }
};

export default FilePreviewModal;
